// extracted by mini-css-extract-plugin
export var graphic = "styles-module--graphic--9941b";
export var heading = "styles-module--heading--869b0";